// STRICT - @ts-expect-error - to be typed
import FESegmentUtils from '@spothero/utils/segment';
/**
 * Spreads the user traits set at `identify` time onto every event's
 * properties, so destinations that only read event properties (not
 * `context.traits`) receive them.
 * @returns {object} user traits object to merge into properties
 */
export const withUserTraits = () => FESegmentUtils.getUserTraits() ?? {};
